<template>
  <div class="card-query">
    <!-- 顶部导航栏 -->
    <div class="header">
      <div class="back-btn" @click="goBack">
        <svg viewBox="0 0 24 24" class="back-icon"><path d="M15 4 L7 12 L15 20" fill="none" stroke="#333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
      </div>
      <div class="title">社保卡信息查询</div>
    </div>

    <!-- 分组标题条 -->
    <div class="group-strip">社会保障卡信息</div>

    <!-- 信息列表 -->
    <div class="info-list">
      <div v-for="row in rows" :key="row.label" class="info-row">
        <span class="row-label">{{ row.label }}</span>
        <span class="row-value">{{ row.value }}</span>
        <span v-if="row.action" class="view-btn" @click="handleViewCard">查看卡号</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SocialCardQuery',
  data() {
    return {
      rows: [
        { label: '省人员识别号', value: '********7013' },
        { label: '社会保障号', value: '**********5619' },
        { label: '姓名', value: '**杰' },
        { label: '证件类型', value: '居民身份证（户口簿）' },
        { label: '证件号码', value: '**********5619' },
        { label: '国家/地区', value: '中国' },
        { label: '性别', value: '男' },
        { label: '移动电话', value: '173****8469' },
        { label: '银行类别', value: '工商银行' },
        { label: '通讯地址', value: '安徽省来安县********' },
        { label: '社保卡状态', value: '正常' },
        { label: '卡变更类型', value: '新发卡' },
        { label: '金融状态', value: '未激活' },
        { label: '银行账号', value: '**********2033', action: true }
      ]
    }
  },
  methods: {
    goBack() {
      this.$router.back()
    },
    handleViewCard() {
      console.log('查看卡号')
    }
  }
}
</script>

<style scoped>
.card-query {
  background: #fff;
  min-height: 100%;
}
/* 顶部导航栏 */
.header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(130 * var(--w));
  background: #fff;
  border-bottom: 1px solid #e5e5e5;
}
.back-btn {
  position: absolute;
  left: 0;
  top: 0;
  width: calc(110 * var(--w));
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.back-icon {
  width: calc(36 * var(--w));
  height: calc(36 * var(--w));
}
.title {
  font-size: calc(46 * var(--w));
  color: #333;
}
/* 分组标题条 */
.group-strip {
  height: calc(66 * var(--w));
  line-height: calc(66 * var(--w));
  padding-left: calc(24 * var(--w));
  background: #f8f8f8;
  font-size: calc(40 * var(--w));
  color: #bfbfbf;
}
/* 信息列表 */
.info-list {
  background: #fff;
}
.info-row {
  display: flex;
  align-items: center;
  height: calc(127 * var(--w));
  padding-left: calc(48 * var(--w));
  border-bottom: 1px solid #ececec;
}
.row-label {
  width: calc(308 * var(--w));
  flex-shrink: 0;
  font-size: calc(44 * var(--w));
  color: #333;
}
.row-value {
  flex: 1;
  font-size: calc(44 * var(--w));
  color: #b7b7b7;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.view-btn {
  flex-shrink: 0;
  padding: 0 calc(30 * var(--w)) 0 calc(28 * var(--w));
  border-left: 1px solid #e5e5e5;
  font-size: calc(44 * var(--w));
  font-weight: 500;
  color: #3a7afe;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/SocialCardQuery.vue